// extracted by mini-css-extract-plugin
export default {"video":"landingPage_video__YBW7f","buttonn":"landingPage_buttonn__rmo07","button":"landingPage_button__oxUbC","glowing-button-85":"landingPage_glowing-button-85__ODHzC"};